import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import PurchaseOrderService from "../../Controller/PurchaseOrderController";
import CountryService from "../../../Setup/controller/CountryController/CountryController";
import { handleChange, handleSubmit } from "../../Controller/UpdateDeliveryAddressController";
import HelpSite from "../../../Common/HelpLink";
function PurchaseOrderAddress({ PurchaseOrderID }) {
    const navigate = useNavigate();
    const location = useLocation();
    const [errors, setErrors] = useState({});
    const [CountryList, setCountries] = useState([]);
    const [formData, setFormData] = useState({
        deliv_FullName: "",
        deliv_Address1: "",
        deliv_Address2: "",
        deliv_Address3: "",
        deliv_Town: "",
        deliv_County: "",
        deliv_Country: "",
        deliv_Telephone: "",
        deliv_PostCode: ""
    });
    const { theme } = useContext(ThemeContext);
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    let accordTheme = "accordion-header-light";
    if (theme === "dark") {
        accordTheme = "accordion-header-dark";
    }

    useEffect(() => {
        fetchCountries();
        if (PurchaseOrderID > 0) {
            fetchPurchaseOrderDetail();
        }
        else {
            resetForm();
        }
    }, [PurchaseOrderID]);
    const fetchCountries = async () => {
        try {
            const listOfCountries = await CountryService.GetAllCountries();
            setCountries(listOfCountries);
        } catch (error) {
            console.error('Error fetching countries:', error);
        }
    };
    const fetchPurchaseOrderDetail = async () => {
        try {
            const redirectCallback = () => navigate('/');

            if (PurchaseOrderID > 0) {
                const purchaseOrderDetail = await PurchaseOrderService.GetPurchaseOrderByID(redirectCallback, PurchaseOrderID);
                const purchaseOrder = purchaseOrderDetail[0];
                setFormData({
                    ...purchaseOrder,
                });
            }
        } catch (error) {
            console.error('Error fetching agreement details:', error);
        }
    };
    const handleFormSubmit = async (event) => {
        event.preventDefault();

        try {
            const redirectUserList = () => {
                navigate('/PurchasingList?saved=true');
            };
            const message = await handleSubmit(event, formData, setFormData, setErrors);
            if (message == "Data saved successfully") {
                setShowSuccessMessage(true);
                window.scrollTo({ top: 0, behavior: 'smooth' });
                setTimeout(() => {
                    setShowSuccessMessage(false);
                }, 5000);
            }
            else {
                setShowErrorMessage(true);
                window.scrollTo({ top: 0, behavior: 'smooth' });
                setTimeout(() => {
                    setShowErrorMessage(false);
                }, 5000);

            }
            fetchPurchaseOrderDetail();
        } catch (error) {
            console.error('Error submitting form:', error);
            setErrors({ submit: 'An error occurred while submitting the form. Please try again.' });
        }
    };
    const handleFieldChange = (event) => {
        handleChange(event, formData, setFormData);
    };
    const resetForm = () => {

        setFormData({
            deliv_FullName: "",
            deliv_Address1: "",
            deliv_Address2: "",
            deliv_Address3: "",
            deliv_Town: "",
            deliv_County: "",
            deliv_Country: "",
            deliv_Telephone: "",
            deliv_PostCode: ""
        });
    };
    const HelpLink = localStorage.getItem('HelpLink');
    return (
        <div>
            {showSuccessMessage && (
                <div class="alert alert-success bg-success text-light border-0 alert-dismissible fade show" role="alert">
                    Data saved successfully.
                </div>
            )}
            {showErrorMessage && (
                <div class="alert alert-danger bg-danger text-light border-0 alert-dismissible fade show" role="alert">
                    Validation Error.

                </div>
            )}
            <div className="row mb-3" style={{ "marginLeft": "0px" }}>
                <div className="col-xl-12" style={{ "textAlign": "right" }}>

                </div>
            </div>
            <form onSubmit={handleFormSubmit}>
                <div className="row mb-3" style={{ marginRight: "5px", marginTop: "10px" }}>
                    <table style={{ width: "100%" }}>
                        <tbody>


                            <tr>
                                <td style={{ width: "13%" }}><label htmlFor="deliv_CompanyName" style={{ float: "right" }}>Company <span style={{ "color": "red" }}>*</span></label></td>
                                <td style={{ width: "37%" }}>
                                    <input type="text" className="form-control" name="deliv_CompanyName" value={formData.deliv_CompanyName} onChange={handleFieldChange} />
                                    {errors.deliv_CompanyName && <div style={{ color: 'red' }}>{errors.deliv_CompanyName}</div>}
                                </td>
                                <td style={{ width: "13%" }}><label htmlFor="deliv_FullName" style={{ float: "right" }}>Name <span style={{ "color": "red" }}>*</span></label></td>
                                <td style={{ width: "37%" }}>
                                    <input type="text" className="form-control" name="deliv_FullName" value={formData.deliv_FullName} onChange={handleFieldChange} />
                                    {errors.deliv_FullName && <div style={{ color: 'red' }}>{errors.deliv_FullName}</div>}
                                </td>
                            </tr>
                            <tr>
                                <td><label htmlFor="deliv_Address1" style={{ float: "right" }}>Address <span style={{ "color": "red" }}>*</span></label></td>
                                <td colSpan={3}>
                                    <input type="text" className="form-control" name="deliv_Address1" value={formData.deliv_Address1} onChange={handleFieldChange} />
                                    {errors.deliv_Address1 && <div style={{ color: 'red' }}>{errors.deliv_Address1}</div>}
                                </td>
                            </tr>
                            <tr>
                                <td><label htmlFor="deliv_Address2" style={{ float: "right" }}></label></td>
                                <td colSpan={3}>
                                    <input type="text" className="form-control" name="deliv_Address2" value={formData.deliv_Address2} onChange={handleFieldChange} />
                                    {errors.deliv_Address2 && <div style={{ color: 'red' }}>{errors.deliv_Address2}</div>}
                                </td>
                            </tr>
                            <tr>
                                <td><label htmlFor="deliv_Address3" style={{ float: "right" }}></label></td>
                                <td colSpan={3}>
                                    <input type="text" className="form-control" name="deliv_Address3" value={formData.deliv_Address3} onChange={handleFieldChange} />
                                    {errors.deliv_Address3 && <div style={{ color: 'red' }}>{errors.deliv_Address3}</div>}
                                </td>
                            </tr>
                            <tr>
                                <td><label htmlFor="deliv_Town" style={{ float: "right" }}>Town <span style={{ "color": "red" }}>*</span></label></td>
                                <td>
                                    <input type="text" className="form-control" name="deliv_Town" value={formData.deliv_Town} onChange={handleFieldChange} />
                                    {errors.deliv_Town && <div style={{ color: 'red' }}>{errors.deliv_Town}</div>}
                                </td>
                                <td><label htmlFor="deliv_County" style={{ float: "right" }}>County <span style={{ "color": "red" }}>*</span></label></td>
                                <td>
                                    <input type="text" className="form-control" name="deliv_County" value={formData.deliv_County} onChange={handleFieldChange} />
                                    {errors.deliv_County && <div style={{ color: 'red' }}>{errors.deliv_County}</div>}
                                </td>
                            </tr>
                            <tr>
                                <td><label htmlFor="deliv_PostCode" style={{ float: "right" }}>Post Code <span style={{ "color": "red" }}>*</span></label></td>
                                <td>
                                    <input type="text" className="form-control" name="deliv_PostCode" value={formData.deliv_PostCode} onChange={handleFieldChange} />
                                    {errors.deliv_PostCode && <div style={{ color: 'red' }}>{errors.deliv_PostCode}</div>}
                                </td>
                                <td><label htmlFor="deliv_Telephone" style={{ float: "right" }}>Telephone <span style={{ "color": "red" }}>*</span></label></td>
                                <td>
                                    <input type="text" className="form-control" name="deliv_Telephone" value={formData.deliv_Telephone} onChange={handleFieldChange} />
                                    {errors.deliv_Telephone && <div style={{ color: 'red' }}>{errors.deliv_Telephone}</div>}
                                </td>
                            </tr>
                            <tr>
                                <td><label htmlFor="deliv_Country" style={{ float: "right" }}>Country <span style={{ "color": "red" }}>*</span></label></td>
                                <td>
                                    <select name="deliv_Country" className='form-control' value={formData.deliv_Country} onChange={handleFieldChange}>
                                        <option value="0">Select Country</option>
                                        {CountryList.map((country) => (
                                            <option key={country.PK_Country_ID} value={country.PK_Country_ID}>
                                                {country.vc_CountryName}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.vc_Country && <div style={{ color: 'red' }}>{errors.vc_Country}</div>}
                                </td>

                            </tr>
                            <tr>
                                <td colSpan={3}></td>
                                <td style={{ float: "right" }}>
                                    <button type="submit" className={`btn btn-primary btn-sm ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`}>
                                        <img src="assets/img/resources/update-icon.png" alt="Add icon" style={{ height: "10px" }} /> Save
                                    </button>

                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </form>


        </div>


    );
}
export default PurchaseOrderAddress;

